module.exports = __webpack_public_path__ + "static/media/briefcase.c28096cb.svg";